<script>
import Languages from "../lang/lang";
import FarmInfo from "./farm/FarmInfo.vue";
import FarmSummary from "./farm/FarmSummary.vue";
import FarmTabs from "./farm/FarmTabs.vue";

export default {
  components: {FarmSummary, FarmInfo, FarmTabs},
  data: function () {
    return {
      farm: null
    }
  },
  props: ['farmId'],
  mounted() {
    window.scrollTo(0, 0);
    fetch(window['API_URL'] + '/api/v4/client/group-mining/' + this.farmId + '/all', {
      headers: {
        'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
      }
    }).then(res => res.json())
        .then(res => {
          console.info(res.data);
          this.farm = res.data;
        });
  },
  computed: {
    generalLang() {
      return Languages.texts('general');
    },
    data() {
      return window['xive']['userData'];
    }
  }
}
</script>

<template>
  <div>
    <div class="back-link">
      <router-link to="/">{{ generalLang['back'] }}</router-link>
    </div>
    <div class="loading-farm" v-if="farm == null">
      Getting farm details...
    </div>
    <template v-if="farm != null">
      <FarmSummary :data="farm" :btc-price="data.btcPrice" />
      <FarmInfo :farm="farm" />
      <FarmTabs :farm="farm" />
    </template>
  </div>
</template>